// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"pQ-z","inlineTitle":"qQ-z","sponsoredAdsWrapper":"rQ-z","marketplaceRecosWrapper":"sQ-z"};